export default "__VITE_ASSET__991376b3__$_?component__"